import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Utils } from '../../../../../../utils/utils';

@Component({
    selector: 'osh-importprotocols-popup',
    templateUrl: './importprotocols-popup.component.html',
    styleUrls: ['./importprotocols-popup.component.less',
        '../../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class ImportProtocolsPopupComponent implements OnInit {

    form = new FormControl();
    list: OshWave[] = []
    
    constructor(
        private readonly http: HttpClient
        , public dialogRef: MatDialogRef<ImportProtocolsPopupComponent>
        , private readonly toastrService: ToastrService,
        @Inject('BASE_URL') private readonly baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {
        this.getWaves()
    }

    getWaves() {
        Utils.httpGetOshWaves(
            this.http,
            this.baseUrl,
            this,
            function (tthis: ImportProtocolsPopupComponent, list: any) {
                tthis.list = list.filter((wave: OshWave) => wave.waveId !== tthis.data.waveId)
            },
            null)
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }
    
    addButtonHandler(waveId: number) {
        Utils.httpImportOshProtocols(
            this.http,
            this.baseUrl,
            waveId,
            this.data.waveId,
            this,
            function (tthis: ImportProtocolsPopupComponent, list: any) {
                tthis.toastrService.success('Protocols imported successfully');
                tthis.dialogRef.close();
            },
            function (tthis: ImportProtocolsPopupComponent, error: any) {
                tthis.toastrService.error('Error importing Protocols');
            }
        )
    }
}

interface OshWave {
    waveId: number;
    name: string;
    description?: string;
    startDate?: Date;
    endDate?: Date;
    changedBy: string;
}

